<app-customer-account-dialog>
  <div id="content">
    <div class="overlay filterData filterDataControls">

      <div class="overlay-header">
        <h6>Filters</h6>
        <div class="close-btn">
          <button mat-icon-button mat-dialog-close (click)="closeFilter()">
            <f-icon icon-config='{"iconName": "xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
          </button>
        </div>
      </div>
      <div class="section-divider"></div>
      <form id="filterForm" class="form-scroll" [formGroup]="filterCurrentBatchAlertForm">
        <div class="overlay-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h6>Created Date Range</h6>
              </div>
            </div>
            <div class="row border-bottom" >
              <div class="col-md-6 flex">
               <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Date From (MMM-DD-YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker1" [max]="maxDate"
                      formControlName="start" (dateChange)="addEvent( $event)" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Date To (MMM-DD-YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker2" [min]="minDate" [max]="maxDate"
                      formControlName="end" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">

                <h6>Created By <span> (Max. 3 users per search)</span> </h6>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type user name here. e.g. Michaelangelo A</mat-label>
                  <mat-chip-grid #chipList1 aria-label="Topic selection">
                    <mat-chip-row *ngFor="let createdBy of selectedCreatedBy" (removed)="removeCreatedBy(createdBy)">
                      {{createdBy}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip-row>

                    <input matInput placeholder="" #createdByInput [formControl]="createdByValue" [matAutocomplete]="auto1"
                      [matChipInputFor]="chipList1" (matChipInputTokenEnd)="addCreatedBy($event)">
                  </mat-chip-grid>
                  <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selectedCreatedBys($event)">
                    <mat-option *ngFor="let createdBy of filteredCreatedBy | async" [value]="createdBy" class="truncate">
                      {{createdBy}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p *ngIf="isMaxCreatedBy" class="error">Only 3 users can be selected.</p>
              </div>
            </div>
            <div class="row section-divider "></div>
            <div class="row">
              <div class="col-md-12">

                <h6>Title <span> (Max. 3 titles per search)</span> </h6>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type title here. e.g. Health related</mat-label>
                  <mat-chip-grid #chipList2 aria-label="Title selection">
                    <mat-chip-row *ngFor="let title of selectedTitles" (removed)="removeTitle(title)">
                      {{title}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip-row>

                    <input  matInput placeholder="" #titleInput [formControl]="titleValue" [matAutocomplete]="auto2"
                      [matChipInputFor]="chipList2" (matChipInputTokenEnd)="addTitle($event)">
                  </mat-chip-grid>
                  <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selectedTitle($event)">
                    <mat-option *ngFor="let title of filteredTitle | async" [value]="title" class="truncate">
                      {{title}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p  *ngIf="isMaxTitle" class="error">Only 3 titles can be selected.</p>
              </div>
            </div>
            <div class="row section-divider"></div>
            <div class="row">
              <div class="col-md-12">

                <h6>Description <span> (Max. 3 descriptions per search)</span> </h6>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type description here. e.g. Health related</mat-label>
                  <mat-chip-grid #chipList3 aria-label="Topic selection">
                    <mat-chip-row *ngFor="let description of selectedDescriptions"
                      (removed)="removeDescription(description)">
                      {{description}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip-row>

                    <input matInput placeholder="" #descriptionInput [formControl]="descriptionValue" [matAutocomplete]="auto3"
                      [matChipInputFor]="chipList3" (matChipInputTokenEnd)="addDescription($event)">
                  </mat-chip-grid>
                  <mat-autocomplete #auto3="matAutocomplete" (optionSelected)="selectedDescription($event)">
                    <mat-option *ngFor="let description of filteredDescription | async" [value]="description"
                      class="truncate">
                      {{description}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p *ngIf="isMaxDescription" class="error">Only 3 descriptions can be selected.</p>
              </div>
            </div>
            <div class="row section-divider"></div>
          </div>
        </div>
      </form>
      <div class="button-controls">

        <f-button text="Clear all" title="Clear all" (click)="clearAll()" type="button" variant="action"></f-button>
        <f-button text="Apply" title="Apply" (click)="apply()" [disabled]="disableApplyButton()" [ngClass]="{disableBtn: disableApplyButton()}" type="button" variant="progressive"></f-button>
      </div>



    </div>
  </div>
</app-customer-account-dialog>